<template>
    <header class="toolbar" :class="{mobile: breakpoint.xs}">
      <div class="content">
        <flex-layout class="w-100" justify="center" align="center">
          <div>
            <div class="d-flex justify-content-center align-items-center">
              <base-image class="mt-1" src="housedo-logo-white.svg" :max-width="140" />
              <base-title
                class="ms-4 title"
                color="white"
                border
                size="xs"
                >
                マイページ
              </base-title>
            </div>
            <slot />
          </div>
        </flex-layout>
      </div>
    </header>
</template>

<script lang="ts" setup>
import BaseImage from '@/components/Images/BaseImage.vue';
import FlexLayout from '@/components/Layouts/FlexLayout.vue';
import { useBreakpoint } from '@/composable/ui/useScreen';
import BaseTitle from "@/components/Texts/BaseTitle.vue";

const breakpoint = useBreakpoint();
</script>

<style scoped>
.toolbar {
  width: 100%;
  height: 96px;
  margin-top: 0px;
  transform: translateY(0px);
  left: 0px;
  right: 0px;
  top: 0;
  z-index: 5;
  background-color: var(--primary);
  display: flex;
  justify-content: center;
  align-items: center;
}

.toolbar.mobile {
  height: 56px!important;
}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
}

.title {
  box-shadow: inset 0 0 0 1px var(--offWhite);
  font-size: 16px !important;
}
</style>
